var AreaChartModule = /** @class */ (function () {
    function AreaChartModule() {
    }
    return AreaChartModule;
}());
export { AreaChartModule };
